<template>
  <component
    v-bind = "containerTag.props"
    :is = "containerTag.name">
    <slot name = "before-name" />
    <component
      v-bind = "{...parrierTag.props, ...customBind.name || {} }"
      :is = "parrierTag.name">
      <form v-on:submit.prevent="submitAttemp">
        <v-text-field
          v-bind = "{ ...customBind.nameInput || {} , ...textFieldProps}"
          v-model = "input.utterance"
          placeholder = "Type Your Item Name" />
      </form>
    </component>
    <slot
      v-for = "(slot, s) in new Array(slots)"
      :name = "`tail-slot-${ s + 1 }`" />
  </component>
</template>

<script>
export default {
  name: 'EntitySublist',
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: 'tr',
          props: {
            class: ''
          }
        }
      }
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: 'td',
          props: {
            class: ''
          }
        }
      }
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true
        }
      }
    },
    slots: {
      type: Number,
      default: 2
    },
    customBind: {
      type: Object,
      default() {
        return {}
      }
    },
    put: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isValid: false,
      input: {
        utterance: '',
      },
      typeItems: []
    }
  },
  mounted() {
  },
  watch: {
    put(val) {
      if (val) this.input = val
      else this.resetForm()
    }
  },
  methods: {
  	handler(e) {
  		// console.log(e)
  	},
    submitAttemp() {
      this.$emit('submit-attemp')
    },
    formatSampleUtterance(text) {
      let result = text.replaceAll(/[^ ][!@#$%^&*(),.?":{}|<>]/g, (val) => {
        return `${val[0]} ${val[1]}`
      })
      result = result.replaceAll(/[!@#$%^&*(),.?":{}|<>][^ ]/g, (val) => {
        return `${val[0]} ${val[1]}`
      })
      return result
    },
    submit() {
      if (this.input.utterance.length) {
        this.emitLoading(true)
        const payload = this.put
          ? { name: this.put.utterance, id: this.put.id }
          : { ...this.input }
        payload.utterance = this.formatSampleUtterance(this.input.utterance)
        this.$store
          .dispatch(`nlp/intents/samples/${this.put ? 'update' : 'add'}`, payload)
          .then(response => {
            this.resetForm()
            this.emitLoading(false)
            this.$emit('success', response.data)
          })
          .catch(err => {
            this.emitLoading(false)
            this.$store.dispatch('setErrorMessage', true)
            this.$emit('error', err)
          })
      } else {
        this.$store.dispatch('setErrorMessage', 'Item name is required.')
      }
    },
    async resetForm() {
      this.input = {
        utterance: ''
      }
      return true
    },
    emitLoading(status = true) {
      this.$emit('loading', status)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
